import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  AUTH_HELP,
  CONFIRM_CLOUD_PAY_ROUTE,
  CONFIRM_ROUTE,
  LECTION_ROUTE,
  MAIN_ROUTE,
  PLAYER_CONSPECT_ROUTE,
  PLAYER_ROUTE,
  PURCHASE_ROUTE,
  PURCHASE_ROUTE_TEST,
  SIGN_IN_EMPTY_2_ROUTE,
  SIGN_IN_EMPTY_ROUTE,
  SIGN_IN_ROUTE,
  SPPORT_ROUTE,
  STATS_ROUTE,
} from '../../constant/routes';
import { LectionPage } from '../../page/LectionPage';
import { SignInPage } from '../../page/SignInPage';
import { MainPage } from '../../page/MainPage';
import { SectionPage } from '../../page/SectionPage';
import { WorkspacePage } from '../../page/WorkspacePage';
import { SignInEmptyPage } from '../../page/SignInEmptyPage';
import { PlayerPage } from '../../page/PlayerPage';
import { DARK_THEME, LIGHT_THEME } from '../../constant/constants';
import { SignInEmptyPage2 } from '../../page/SignInEmptyPage2';
import { LendingSuppportPage } from '../../page/LendingSupportPage';
import { PurchasePage } from '../../page/PurchasePage';
import { AutoConfirmPage } from '../../page/AutoConfirmPage';
import { PlayerConspectDiv } from '../player-conspect/PlayerConspectDiv';
import { PurchasePageTest } from '../../page/PurchaseTestPage';
import { AutoConfirmCloudPayPage } from '../../page/AutoConfirmCloudPayPage';
import { StatPage } from '../../page/StatsPage';
import { AuthHelpPage } from '../../page/AuthHelpPage';

declare global {
  interface Window {
    webkit?: any;
    AndroidInterface?: {
      videoViewed: (message: string) => void;
      readyToGet: (message: number) => void;
      themeSelected: (message: number) => void;
      endLecture: (message: number) => void;
      curPosition: (message: number) => void;
      authState: (message: number) => void;
    };
  }
}

export const App = () => {
  const [themeFromMain, setThemeFromMain] = useState<number>(LIGHT_THEME);
  const [positionFromMain, setPositionFromMain] = useState<number>(-1);
  const [isScreenShot, setScreenShot] = useState<number>(0);

  const readyToSend = () => {
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit?.messageHandlers?.readyToGet?.postMessage(1);
    }
    if (window.AndroidInterface) {
      window.AndroidInterface?.readyToGet(1);
    }
  };

  const sendColorTheme = (colorType: number) => {
    readyToSend();
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit?.messageHandlers?.themeSelected?.postMessage(colorType);
    }
    if (window.AndroidInterface) {
      window.AndroidInterface?.themeSelected(colorType);
    }
  };

  const sendVideoLink = (link: string) => {
    readyToSend();
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit?.messageHandlers?.videoViewed?.postMessage(link);
    }
    if (window.AndroidInterface) {
      window.AndroidInterface?.videoViewed(link);
    }
  };

  const sendEndLection = () => {
    readyToSend();
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit?.messageHandlers?.endLecture?.postMessage(1);
    }
    if (window.AndroidInterface) {
      window.AndroidInterface?.endLecture(1);
    }
  };

  const sendPosition = (posit: number) => {
    readyToSend();
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit?.messageHandlers?.curPosition?.postMessage(posit);
    }
    if (window.AndroidInterface) {
      window.AndroidInterface?.curPosition(posit);
    }
  };

  const sendAuthState = (auth: number) => {
    readyToSend();
    if (window.AndroidInterface) {
      window.AndroidInterface?.authState(auth);
    }
  };

  window.setPosition = (info: number) => {
    setPositionFromMain(info);
  };

  window.setTheme = (info: number) => {
    setThemeFromMain(info);
    let colorBody = '#FFFFFF';
    if (info === DARK_THEME) {
      colorBody = '#1D2228';
    }
    document.body.style.background = colorBody;
  };

  window.setScreenShot = (info: number) => {
    setScreenShot(info);
  };

  return (
    <div translate="no">
      <Routes>
        <Route path={SIGN_IN_EMPTY_ROUTE} element={<SignInEmptyPage />} />
        <Route path={SIGN_IN_EMPTY_2_ROUTE} element={<SignInEmptyPage2 />} />
        <Route path={SIGN_IN_ROUTE} element={<SignInPage />} />
        <Route path={MAIN_ROUTE} element={<MainPage />} />
        <Route path={`${MAIN_ROUTE}/:section`} element={<SectionPage />} />
        <Route
          path={`${MAIN_ROUTE}/:section/:route`}
          element={<WorkspacePage />}
        />
        <Route
          path={`${PLAYER_ROUTE}/:route/:keyTitle/:id/:secureToken/:apiVersion/:accessToken`}
          element={
            <PlayerPage
              selectThemeFromMain={themeFromMain ?? LIGHT_THEME}
              onChange={sendVideoLink}
            />
          }
        />
        <Route
          path={`${PLAYER_CONSPECT_ROUTE}/:id`}
          element={
            <PlayerConspectDiv
              selectThemeFromMain={themeFromMain ?? LIGHT_THEME}
              onChange={sendVideoLink}
            />
          }
        />
        <Route
          path={`${PLAYER_CONSPECT_ROUTE}/:secureToken/:apiVersion/:accessToken/:id`}
          element={
            <PlayerConspectDiv
              selectThemeFromMain={themeFromMain ?? LIGHT_THEME}
              onChange={sendVideoLink}
            />
          }
        />
        <Route
          path={`${LECTION_ROUTE}/:secureToken/:apiVersion/:accessToken/:section/:lectionId/:main/:secondary/:secondaryBlack`}
          element={
            <LectionPage
              screenShot={isScreenShot}
              selectThemeFromMain={themeFromMain ?? LIGHT_THEME}
              selectPosition={positionFromMain}
              onChange={sendColorTheme}
              onChange2={sendEndLection}
              onChange5={sendPosition}
            />
          }
        />
        <Route
          path={`${LECTION_ROUTE}/:section/:lectionId`}
          element={
            <LectionPage
              screenShot={isScreenShot}
              selectThemeFromMain={themeFromMain ?? LIGHT_THEME}
              selectPosition={positionFromMain}
              onChange={sendColorTheme}
              onChange2={sendEndLection}
              onChange5={sendPosition}
            />
          }
        />
        <Route path={SPPORT_ROUTE} element={<LendingSuppportPage />} />
        <Route
          path={`${SPPORT_ROUTE}/:idSupport/:timestamp/:crc`}
          element={<LendingSuppportPage />}
        />
        <Route
          path={`${PURCHASE_ROUTE}/:userId`}
          element={<PurchasePage onChange={sendAuthState} />}
        />
        <Route
          path={`${PURCHASE_ROUTE_TEST}`}
          element={<PurchasePage onChange={sendAuthState} />}
        />
        <Route
          path={`${PURCHASE_ROUTE}`}
          element={<PurchasePageTest onChange={sendAuthState} />}
        />
        <Route
          path={`${CONFIRM_ROUTE}/:lendingId/:appId`}
          element={<AutoConfirmPage />}
        />
        <Route
          path={`${CONFIRM_CLOUD_PAY_ROUTE}/:lendingId/:appId`}
          element={<AutoConfirmCloudPayPage />}
        />
        <Route path={`${AUTH_HELP}/:authId`} element={<AuthHelpPage />} />
      </Routes>
    </div>
  );
};

export default App;
